// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"0f3d3913","304":"fcde4724","780":"7bef7fc3","816":"72c2ac7a"}[chunkId] + ".chunk.css";
};